import React, { useRef, useState, useEffect } from 'react';
import { useIntl } from 'umi';
import classnames from 'classnames';
import { Switch, Text } from 'tea-component';
import CompareCore from '../../components/CompareCore';
import HeaderColumnRenderer from './renderers/HeaderColumnRenderer';
import { generateMetrics } from '../../utils/dataSourcesMetrics';
import { PERIODS_METRICS_CONFIG } from '../../constants';
import type { IBaseProps } from '@/pages/intelligence/types/common';
import type { IFilter } from '@/pages/intelligence/types/pcConsoleCompare';
import type { ICompareCoreInstance } from '../../components/CompareCore/types';
import { ComposedDateMode } from '@/pages/intelligence/components/ComposedDatePicker/enums';
import moment from 'moment';
const {
  PAGE_KEY,
  PAGE_NAME,
  ENTITY_TYPES,
  PERIODS,
  DATA_SOURCES_METRICS,
  DEVICES,
  DATE_TYPE,
  DATE_TYPES,
  VISUALIS_TOOLTIP_TITLE,
  PAGE_LOG_KEY,
} = PERIODS_METRICS_CONFIG.PCU;
const METRICS_OPTIONS = generateMetrics(DATA_SOURCES_METRICS);
const METRICS_VALUES = METRICS_OPTIONS?.map((metric) => metric?.value) || [];

type IPCUProps = IBaseProps;

export default function PCU(props: IPCUProps) {
  const { style, className } = props;

  const { formatMessage } = useIntl();

  const compareCoreInstance = useRef<ICompareCoreInstance | null>(null);

  const [filter, setFilter] = useState<IFilter>({
    devices: [...DEVICES],
    metrics: [...METRICS_VALUES],
    // 是否开启Heat Map模式，展示各个阶段，各个指标的 最优指标值
    isHeatMap: false,
  });
  const handleIsHeatMapChange = (value: boolean) => {
    const filterTemp = {
      ...filter,
      isHeatMap: value,
    };
    setFilter(filterTemp);
  };

  /** 页面初始化逻辑，不带任何条件查询 对比结果数据 **/
  useEffect(() => {
    if (!compareCoreInstance.current) return;
    compareCoreInstance.current?.updateCompareTableData({
      callback: (res)=>{
        const endDate = moment().format('YYYY-MM-DD');
        const startDate = moment().subtract('1','months').format('YYYY-MM-DD');
        compareCoreInstance.current?.updateCompareTrendsData({games: res,composedDateData: {dateType: DATE_TYPE,mode: ComposedDateMode.Absolute,dateValue: [startDate,endDate]}});
      }
    });

  }, []);
  /** 页面初始化逻辑，不带任何条件查询 对比结果数据 **/

  return (
    <div style={style} className={classnames('dbi-pc-console-compare', className)}>
      {/* 筛选器 */}
      <div className="dbi-pc-console-compare_filter">
        <Switch
          className="dbi-pc-console-compare_switcher dbi-common-switcher"
          disabled={false}
          value={filter?.isHeatMap}
          onChange={handleIsHeatMapChange}
        >
          <Text>{formatMessage({ id: 'dbi_compare_heat_map' })}</Text>
        </Switch>
      </div>
      <CompareCore
        ref={compareCoreInstance}
        pageKey={PAGE_KEY}
        pageName={PAGE_NAME}
        entityTypes={ENTITY_TYPES}
        filter={filter}
        periods={PERIODS}
        devices={DEVICES}
        dateType={DATE_TYPE}
        dateTypes={DATE_TYPES}
        visualisTooltipTitle={VISUALIS_TOOLTIP_TITLE}
        pageLogKey={PAGE_LOG_KEY}
        isOnlySingleMetricLine={false}
        headerColumnRenderer={HeaderColumnRenderer}
      />
    </div>
  );
}
